import React from 'react';
import './CustomSection.css';

const CustomSection = () => {
  const customExamples = [
    {
      id: 1,
      image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400',
      title: 'Name on Back',
      description: 'Personalized with your name'
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=400',
      title: 'Custom Number',
      description: 'Your lucky number'
    },
    {
      id: 3,
      image: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?w=400',
      title: 'Team Logo',
      description: 'Your team identity'
    }
  ];

  return (
    <section className="section custom-section" id="custom">
      <div className="container">
        <h2 className="section-title">Custom T-Shirts</h2>
        <p className="section-subtitle">Make it uniquely yours with custom designs</p>

        <div className="custom-examples">
          {customExamples.map(example => (
            <div key={example.id} className="custom-example-card fade-in">
              <div className="custom-image" style={{ backgroundImage: `url(${example.image})` }}></div>
              <h3>{example.title}</h3>
              <p>{example.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomSection;
